import React from 'react';
import { Button } from 'antd';
import { CodeOutlined } from '@ant-design/icons';

import CompoundPreviewSummaryGridCell from '../../compound/execution/SummaryGridCell';
import QueryExposureModal from '../../../containers/funnel/side/QueryExposureModal';
import isFunnelReadyToExecute from '../../../utils/funnel';
import CompoundSideActionButtons from '../../compound/side/ActionButtons';

const FunnelExecutionSummaryGrid = ({
  item,
  hasPermission,
  onUpdate,
  onDelete,
  onDuplicate,
  description,
  additionalStyle,
  showExposureSQLButton,
}) => {
  const renderButton = (onClick, updatingFunnel) => (
    <Button
      icon={<CodeOutlined />}
      style={{ border: 'none', backgroundColor: 'transparent' }}
      onClick={(e) => {
        onClick();
        e.target.blur();
      }}
      disabled={!isFunnelReadyToExecute(item, updatingFunnel)}
    />
  );

  return (
    <CompoundPreviewSummaryGridCell
      additionalStyle={additionalStyle}
      name={item.name}
      description={description}
    >
      {hasPermission && (
        <CompoundSideActionButtons
          item={item}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
          additionalStyle={additionalStyle}
        >
          {showExposureSQLButton && <QueryExposureModal button={renderButton} />}
        </CompoundSideActionButtons>
      )}
    </CompoundPreviewSummaryGridCell>
  );
};

export default FunnelExecutionSummaryGrid;
